import React , {useState} from 'react';
import styled from 'styled-components';
import ContactLogo from '../resource/Social_notifications.svg';
import twitter from '../resource/Social_buttons/twitter.svg';
import facebook from '../resource/Social_buttons/facebook.svg';
import github from '../resource/Social_buttons/github.svg';

const Container = styled.div`
    color: #010606;
    background: #fff;

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }
`
const Wrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 600px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
    @media screen and (max-width: 768px){
        height: 800px;
    }
`
const Row = styled.div`
    display:grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: 'col1 col2';

    @media screen and (max-width: 768px){
        grid-template-areas: 'col1' 'col2';
    }
`
const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`
const Column2 = styled.div`
    margin-bottom: 15px;
    margin-left: 0px;
    padding: 0 15px;
    grid-area: col2;
    @media screen and (max-width: 768px){
        margin-left: 0px;
    }

`
const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`
const TopLine = styled.p`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`
const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: #010606;

    @media screen and (max-width: 600px) {
        font-size: 32px;
    }
`
const Subtitle = styled.div`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: #010606;
`
const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`
const Btn = styled.div`
    border-radius: 50px;
    background: #cebfff;
    color: #000;
    width: 280px;
    white-space: nowrap;
    padding: 14px 48px;
    font-size: 20px;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background : #cebfff;
        color: #000
    }

`
const ImgWrap = styled.div`
    max-width: 550px;
    height: 100%;
    @media screen and (max-width:786px){
        max-width: 400px;
        margin: 0 auto;
    }
`
const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`
const Socials = styled.div`
    display: flex;
    max-width: 350px;
    justify-content: space-evenly;

`
const Icon = styled.img`
    height: 45px;
    border-radius: 8px;
    width: 45px;
`

const Contact = () => {
    const [email, setEmail] = useState("MistyUX@gmail.com");
    function clickAction() {
        navigator.clipboard.writeText('MistyUX@gmail.com'); 
        setEmail(`Email Copied ✅`);
        setTimeout(resetEmail, 1500);
      }
    function resetEmail(){
        setEmail("MistyUX@gmail.com");
    }
    return(
        <Container id='contact'>          
            <Wrapper>
                <Row>
                    <Column1>
                    <TextWrapper>
                    <TopLine>Contact</TopLine>
                    <Heading>Hire Me. </Heading>
                    <Subtitle>You can contact me via email on : <br/><br/><BtnWrap><Btn onClick={() => {clickAction()}}><span>{email}</span></Btn> </BtnWrap><br/>or on any of my social media.</Subtitle>
                    <Socials>
                    <a style={{textDecoration: "none",color:"#000"}} href='https://twitter.com/Digitalsquest' rel="noreferrer" target='_blank'>
                        <Icon src={twitter} alt='twitter-logo' />
                    </a>
                    <a style={{textDecoration: "none",color:"#000"}} href='https://github.com/Mistydz/' rel="noreferrer" target='_blank'>
                        <Icon src={github} alt='github-logo' />
                    </a>
                    <a style={{textDecoration: "none",color:"#000"}} href='https://facebook.com/admin1331/' rel="noreferrer" target='_blank'>
                        <Icon src={facebook} alt='facebook-logo' />
                    </a>
                    </Socials>                           
                    </TextWrapper>
                    </Column1>
                    <Column2>
                    <ImgWrap>
                            <Img src={ContactLogo} alt='contact-img' />
                    </ImgWrap>
                    </Column2>
                </Row>
                
            </Wrapper>
        </Container>
    )
}

export default Contact
